import { useEffect, useState } from "react";
import axios from "axios";
import ls from 'localstorage-slim';
/**
 * Custom hook to fetch projects information.
 * @returns An object containing the fetched data, loading state, and fetchProjectsInfo function.
 */
const useGetProjectsInfo = () => {
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.REACT_APP_PROJECT_INFO_URL || ""

    /**
     * Fetches projects information from the API.
     */
    const fetchProjectsInfo = async () => {
        try {
            const userdata = ls.get('token-gpt-app')
            //@ts-ignore
            const username = userdata.email.split('@')[0]
            const { data: response } = await axios.post<any>(
                API_URL,
                {
                    "user":username,
                    "fetch_all": "true"
                }
            );
            setData(response);
        } catch (error) {
            setData(null);
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProjectsInfo();
    }, []);

    return { data, loading, fetchProjectsInfo };
};

export default useGetProjectsInfo;